<template>
  <div class="mb-3 bg-secondary-3 px-4 py-2 rounded">
    <div class="row p-3">
      <div class="col-md-4 p-0">
        <div class="color-secondary-6 font-14">Título:</div>
        <div class="color-black font-14">{{ value.title }}</div>
      </div>

      <div class="col-md-3 p-0">
        <div class="color-secondary-6 font-14">Aplica a Proveedor:</div>
        <custom-radio
          v-if="isEditing"
          :id="`providerApplicationRb-${value.proposalDocumentTypeId}`"
          v-model="model.providerApplication"
          class="custom-radio__extended"
          custom-error-msg="Favor seleccione"
          is-inline
          :name="`providerApplicationRb-${value.proposalDocumentTypeId}`"
          :options="applicationProviderOptions"
        />
        <div v-else class="color-black font-14">
          {{ parseProviderApplication(value.providerApplication) }}
        </div>
      </div>

      <div class="col-md-3 p-0">
        <div class="color-secondary-6 font-14">Requerido:</div>
        <custom-radio
          v-if="isEditing"
          :id="`isRequiredRb-${value.proposalDocumentTypeId}`"
          v-model="model.required"
          class="custom-radio__extended"
          custom-error-msg="Favor seleccione"
          is-inline
          :name="`isRequiredRb-${value.proposalDocumentTypeId}`"
          :options="requiredOptions"
        />
        <div v-else class="color-black font-14">
          {{ value.required ? 'Si' : 'No' }}
        </div>
      </div>

      <!-- 🔧 BLOQUE REFACTORIZADO: un solo div que contiene ambos estados -->
      <div class="col-md-2 p-0 text-right">
        <template v-if="!readOnly && !draggableEnabled">
          <action-button
            v-if="canEditDocuments && !isEditing"
            class="mr-2"
            i="fa fa-times-circle"
            variant="outline-danger"
            @click="onDeleteHandler"
          />
          <action-button
            v-if="canEditDocuments && !isEditing"
            i="fa fa-edit"
            variant="success"
            @click="onEditHandler()"
          />
        </template>
        <template v-else-if="draggableEnabled">
          <i class="fas fa-ellipsis-v" />
          <i class="fas fa-ellipsis-v" />
        </template>
      </div>
    </div>

    <div v-if="isEditing" class="row p-3">
      <div class="col-md-12 p-0">
        <div class="color-secondary-6 font-14">Descripción:</div>
        <div class="color-black font-14">{{ value.description | empty }}</div>
      </div>
    </div>

    <div v-if="isEditing" class="d-flex justify-content-end">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 pl-3 pr-4"
        @click="() => (isEditing = false)"
      />
      <action-button
        i="fas fa-save"
        text="Guardar"
        variant="success pl-3 pr-3"
        @click="onSaveDocumentHandler"
      />
    </div>
  </div>
</template>

<script>
import proposalDocumentProviderApplication from '@/utils/constants/proposalDocumentProviderApplication.js';
import ActionButton from 'ActionButton';
import CustomRadio from 'custom-radio';

export default {
  name: 'DocumentRow',
  components: {
    ActionButton,
    CustomRadio,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    permissionToActions: {
      type: String,
      default: () => 'provider.Edit.Configuration.Documents',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    draggableEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEditing: false,
      requiredOptions: [
        { id: 1, name: 'required-rb', value: true, label: 'Si' },
        { id: 2, name: 'required-rb', value: false, label: 'No' },
      ],
      applicationProviderOptions: [
        {
          id: proposalDocumentProviderApplication.Nuevo,
          name: 'providerApplication-rb',
          value: proposalDocumentProviderApplication.Nuevo,
          label: 'Nuevo',
        },
        {
          id: proposalDocumentProviderApplication.Existente,
          name: 'providerApplication-rb',
          value: proposalDocumentProviderApplication.Existente,
          label: 'Existente',
        },
        {
          id: proposalDocumentProviderApplication.Ambos,
          name: 'providerApplication-rb',
          value: proposalDocumentProviderApplication.Ambos,
          label: 'Ambos',
        },
      ],
      model: {
        required: null,
        providerApplication: null,
      },
    };
  },
  computed: {
    canEditDocuments() {
      return this.userHasPermissions(this.permissionToActions);
    },
  },
  watch: {
    draggableEnabled(newVal) {
      if (newVal) {
        this.isEditing = false;
      }
    },
  },
  methods: {
    parseProviderApplication(providerApplication) {
      switch (providerApplication) {
        case proposalDocumentProviderApplication.Nuevo:
          return 'Nuevo';
        case proposalDocumentProviderApplication.Existente:
          return 'Existente';
        case proposalDocumentProviderApplication.Ambos:
          return 'Ambos';
        default:
          return 'Nuevo';
      }
    },
    onEditHandler() {
      this.isEditing = true;
      this.model.required = this.requiredOptions.find(
        (x) => x.value == this.value.required
      );
      this.model.providerApplication = this.applicationProviderOptions.find(
        (x) => x.value == this.value.providerApplication
      );
    },
    onDeleteHandler() {
      this.$emit('on-delete', this.value.proposalDocumentTypeId);
    },
    onSaveDocumentHandler() {
      this.$emit('on-update', {
        proposalDocumentTypeId: this.value.proposalDocumentTypeId,
        required: this.model.required.value,
        providerApplication: this.model.providerApplication.value,
      });

      this.isEditing = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .col-12 {
    padding: 0 !important;
  }
}
</style>
